import React from "react";

import { StatusBadgeProps } from "./statusBadgeProps";

export const OpenStatusBadge = (props: StatusBadgeProps) => {
    const { width, height = "18", viewBox = "0 0 42 18", ...rest } = props;

    return (
        <svg
            data-cy="openBadge"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox={viewBox}
            {...rest}
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="jobstatus/open">
                    <rect
                        id="Rectangle"
                        fill="#6EEDB8"
                        x="0"
                        y="0"
                        width="42"
                        height="17.6904"
                        rx="1.9656"
                    ></rect>
                    <path
                        d="M9.31356562,13.0807719 C12.0028289,13.0807719 13.2409266,11.1113328 13.2409266,8.89427422 C13.2409266,6.67721563 12.0028289,4.70777656 9.31356562,4.70777656 C6.62430234,4.70777656 5.38620469,6.67721563 5.38620469,8.89427422 C5.38620469,11.1113328 6.62430234,13.0807719 9.31356562,13.0807719 Z M9.31356562,11.7850883 C7.56871172,11.7850883 6.92950781,10.4318187 6.92950781,8.89427422 C6.92950781,7.36248828 7.56871172,6.00921875 9.31356562,6.00921875 C11.0584195,6.00921875 11.6976234,7.36248828 11.6976234,8.89427422 C11.6976234,10.4318187 11.0584195,11.7850883 9.31356562,11.7850883 Z M16.2123609,12.9656 L16.2123609,9.59106406 L17.3122523,9.59106406 C18.9707273,9.59106406 20.1857906,8.75606797 20.1857906,7.23579922 C20.1857906,5.69825469 18.9707273,4.82870703 17.3122523,4.82870703 L14.7611953,4.82870703 L14.7611953,12.9656 L16.2123609,12.9656 Z M17.3122523,8.22627734 L16.2123609,8.22627734 L16.2123609,6.19349375 L17.3122523,6.19349375 C18.3027305,6.19349375 18.734625,6.57356094 18.734625,7.23579922 C18.734625,7.88076172 18.3142477,8.22627734 17.3122523,8.22627734 Z M27.0097242,12.9656 L27.0097242,11.5835375 L23.0593289,11.5835375 L23.0593289,9.56802969 L26.7390703,9.56802969 L26.7390703,8.22627734 L23.0593289,8.22627734 L23.0593289,6.17045938 L27.0097242,6.17045938 L27.0097242,4.82870703 L21.5966461,4.82870703 L21.5966461,12.9656 L27.0097242,12.9656 Z M30.1711922,12.9656 L30.1711922,7.24731641 L33.5802797,12.9656 L35.0429625,12.9656 L35.0429625,4.82870703 L33.6378656,4.82870703 L33.6378656,10.5181977 L30.2172609,4.82870703 L28.7660953,4.82870703 L28.7660953,12.9656 L30.1711922,12.9656 Z"
                        id="OPEN"
                        fill="#210071"
                        fillRule="nonzero"
                    ></path>
                </g>
            </g>
        </svg>
    );
};
